"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BrandedAppsFilters = /*#__PURE__*/function () {
  BrandedAppsFilters.$inject = ["EventEmitter"];
  /* @ngInject */
  function BrandedAppsFilters(EventEmitter) {
    _classCallCheck(this, BrandedAppsFilters);
    this.EventEmitter = EventEmitter;
  }
  _createClass(BrandedAppsFilters, [{
    key: "$onChanges",
    value: function $onChanges(_ref) {
      var filters = _ref.filters;
      if (!filters.currentValue) {
        return;
      }
      return this.filters = Object.assign({}, this.filters);
    }
  }, {
    key: "setFilterValue",
    value: function setFilterValue(filter, value) {
      return this.onSetFilterValue(this.EventEmitter({
        filter: filter,
        value: value
      }));
    }
  }, {
    key: "setOrResetFilterValue",
    value: function setOrResetFilterValue(filter, value) {
      var newValue = this.filters[filter].value === value ? null : value;
      return this.setFilterValue(filter, newValue);
    }
  }, {
    key: "resetFilter",
    value: function resetFilter(filter) {
      return this.onSetFilterValue(this.EventEmitter({
        filter: filter,
        value: null
      }));
    }
  }]);
  return BrandedAppsFilters;
}();
module.exports = angular.module('backstage.components.branded-app.branded-app-filters', []).component('brandedAppFilters', {
  templateUrl: '/src/angular/components/branded-app/branded-app-filters/branded-app-filters.html',
  bindings: {
    filters: '<',
    onSetFilterValue: '&'
  },
  controller: BrandedAppsFilters
}).name;